<style lang="scss" scoped>
.trend-percentage-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  img {
    margin-top: -2px; // Align percentage and arrow horizontally
  }
}
</style>

<template>
  <div class="trend-percentage-wrapper">
    <span
      v-if="showPercentage"
      :class="{
        'text-up': isPositive,
        'text-down': isNegative,
        'text-neutral': isNeutral,
        'mr-2': showPercentage && showArrow
      }"
    >
      <span
        v-if="showPercentageIcon"
      >
        {{ percentageFormatted | formatNumbers }}%
      </span>
      <span
        v-else
      >
        {{ percentageFormatted | formatNumbers(0) }}
      </span>
    </span>
    <img
      v-if="showArrow"
      :src="require(`@/assets/img/${arrowIcon}.svg`)"
      :width="arrowWidth"
      :alt="arrowIcon"
    >
    <span
      v-if="hasLabel"
      class="ml-2 text-sm text-bold"
      :class="{
        'text-up': isPositive,
        'text-down': isNegative,
        'text-neutral': isNeutral,
      }"
    >
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'VTrendPercentage',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    showPercentageIcon: {
      type: Boolean,
      default: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    arrowWidth: {
      type: String,
      default: '13px',
    },
    label: {
      type: String,
      default: '',
    },
    showAbsolute: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPositive() {
      return this.percentage > 0;
    },
    isNegative() {
      return this.percentage < 0;
    },
    isNeutral() {
      return this.percentage === 0;
    },
    arrowIcon() {
      if (this.isPositive) {
        return 'ico-arrow-positive';
      }
      if (this.isNegative) {
        return 'ico-arrow-negative';
      }
      return 'ico-arrow-neutral';
    },
    hasLabel() {
      return this.label.length > 0;
    },
    percentageFormatted() {
      if (this.showAbsolute) {
        return Math.abs(this.percentage);
      }
      return this.percentage;
    },
  },
};
</script>
